import { useCallback } from 'react';
import { IconName } from '@optimus-web/icons';
import { AssistantUserPromptLog } from '@mews-commander/data-access';
import { DataTestId } from '@mews-commander/enums';
import { useUpdateFavoriteQuery } from '../../query/useUpdateFavoriteQuery';
import { RemoveSearchPromptButton } from '../styles';

interface Props {
    favorite: AssistantUserPromptLog;
}

export const AssistantRemoveFavoriteButton = ({ favorite }: Props) => {
    const { mutate: removeFavorite } = useUpdateFavoriteQuery();
    const handleRemoveFavorite = useCallback(
        ({ id, prompt }: AssistantUserPromptLog) => {
            removeFavorite({ id, prompt, isFavorite: false });
        },
        [removeFavorite]
    );

    return (
        <RemoveSearchPromptButton
            data-test-id={DataTestId.AssistantDeleteFavoriteSearch}
            icon={IconName.CrossClose}
            tabIndex={0}
            size="small"
            variant="ghost"
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleRemoveFavorite(favorite);
            }}
        />
    );
};
